import { FC, PropsWithChildren } from 'react';

import { IMetaBlockProps, MetaBlock } from '../../../MetaBlock/MetaBlock';
import styles from './DeviceDetailsLine.styles.m.css';

interface IDeviceDetailsLineProps extends PropsWithChildren<IMetaBlockProps> {}

export const DeviceDetailsLine: FC<IDeviceDetailsLineProps> = (props) => {
  const { label, Actions, onClick, children } = props;

  return (
    <MetaBlock
      size="small-2"
      label={label}
      Actions={Actions}
      className={styles.container}
      onClick={onClick}
      children={children}
    />
  );
};
